import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';
import { nuDSColor, spacing } from '@nubank/nuds-web/styles/themeUtils';

const NavigationListLargeScreenWrapper = styled(Box)`
  display: flex;
  width: fit-content;
  list-style: none;
  flex-direction: row;
  align-items: center;

  &::before {
    content: ' ';
    width: 100%;
    height: 5px;
    bottom: 0;
    left: 0;
    position: absolute;
    z-index: -3;
  }

  > li {
    height: 100%;
    margin-right: ${spacing('6x')};
    display: flex;
    align-items: center;

    .menu-navigation-list-item-submenu {
      will-change: transform;
      transition: all .5s .1s;
      transform: translate3d(0, -99%, 0);
      visibility: hidden;
      height: auto;
      padding-bottom: ${spacing('16x')};
      top: 100%;
      overflow: hidden;
      position: absolute;
      z-index: -2;
      box-shadow: 0 1px 1px ${nuDSColor('black', 'defaultT10')};
    }

    &:hover,
    &:focus-within {
      .menu-navigation-link--large-screen {
        ${({ selectedColor }) => `color: ${selectedColor} !important`};
        svg {
          transform: rotate( -180deg );
          transition: transform 150ms ease;
        }
      }

      > .menu-navigation-list-item-submenu {
        visibility: visible;
        transform: translateY(-1%);
        z-index: -1;
      }
    }

    &:last-child {
      margin-right: 0;
    }
  }

  &:hover,
  &:focus-within { 
    > li {
      .menu-navigation-link--large-screen {
        transition: color ease-in 100ms;

        ${({ inactiveColor }) => `color: ${inactiveColor}`};
      }
    }
  }
`;

NavigationListLargeScreenWrapper.displayName = 'NavigationListLargeScreenWrapper';

export default NavigationListLargeScreenWrapper;
